function csOuterfunction(){
  $('[rel="cs-tab2"]').trigger("click");
  $('#csShippingAppCode .CS-custom-tab-section').append('<span class="cs-loader"></span>')
  // Find the specific 'Overseas Shipping' tab
  $(".cs-tab_last[rel='cs-tab1']").find("svg").last().replaceWith(`
      <svg fill="#000000" version="1.1" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 471.461 471.461">
          <g>
              <path d="M235.735,471.456c129.984,0,235.726-105.752,235.726-235.726c0-129.973-105.752-235.725-235.726-235.725
              C105.761,0.005,0,105.747,0,235.73C0,365.714,105.751,471.456,235.735,471.456z M421.152,193.942
              c-19.662-11.465-14.746,1.635-14.746,1.635s0,0,13.109,11.465c13.111,11.466,22.941,16.39,18.025,32.445
              c-4.914,16.057-13.109,1.961-29.49,15.072c-16.391,13.109,19.66,16.389,21.295,36.049c1.637,19.662-19.66,9.832-29.49,29.492
              s-1.635,40.965-6.551,58.99c-4.914,18.025-45.881,42.602-60.76,50.797s-4.781-18.025,0-36.051s-11.34-37.686-11.34-70.457
              s-9.83-22.939-39.322-22.939c-29.49,0-42.6-16.391-45.88-47.518c-3.28-31.135,24.576-62.261,37.685-72.091
              c13.111-9.831,31.137-19.661,49.152-9.831c18.025,9.831,24.576,19.661,44.236,19.661s19.66-6.55,31.135-14.746
              c11.465-8.195-16.391-18.025-32.77-16.313c-16.381,1.712-13.111-9.897-34.406-18.092c-21.297-8.195-29.492,8.195-36.051,11.465
              c-6.551,3.28-29.49,13.11-31.787,0c-2.285-13.11,12.117-14.745,26.871-14.745c14.746,0,1.635-11.465-3.279-19.661
              c-4.916-8.195-14.746-8.195-21.85-14.592c-7.096-6.397,8.74-18.178,25.119-14.267c16.381,3.911,9.83,15.75,27.855,14.114
              s0-18.025,0-33.899c0-15.874,19.662-15.262,32.771-21.592c13.109-6.331,29.49,27.635,40.965,41.377
              c3.797,4.552,9.219,2.534,14.766-2.113c28.984,33.354,48.367,75.228,53.836,121.338
              C436.824,217.695,438.346,203.973,421.152,193.942z"/>
          </g>
      </svg>
  `);
}
function sbzZipcodeUpdate(csPostalCode) {
  if (csPostalCode && $('.cs-tab_last[rel="cs-tab2"]').hasClass('active')) {
    $('.cs-loader').show();
    $(".appended-shipping").remove();
    $("#hidden-shipping-message").remove();
    var postal_code = $('#postal_code').val();
    $('#input_postcode').val(postal_code);
    $("#search_postcode").trigger("click");
    setTimeout(function() {
      // if ($("#cs_shipping_rate .form .ShippingEstimator__Error ").hasClass("activeMsg")) {
      //   var errorMessage = $("#cs_shipping_rate .form").attr('data-ship_err');
      //   if (errorMessage.length > 0) {
      //     $(".input-content-block").after('<div id="hidden-shipping-message" class="shipping-mass" style="display: block;color: red;"></div>');
      //     $("#hidden-shipping-message").append(errorMessage);
      //     $('.cs-loader').hide();
      //     $("#hidden-shipping-message").show();
      //   }
      // } else {
        var shippingElement = $("#shipping_rates").clone();   
        if (shippingElement.length > 0) {
          shippingElement.css("display", "block").addClass("appended-shipping");
          $(".input-content-block").after('<div id="hidden-shipping-message" style="display: none;"></div>');
          $("#hidden-shipping-message").append(shippingElement);
          $('.cs-loader').hide();
          $("#hidden-shipping-message").show();
        }
      // }
    }, 2000);
  }
}
$(document).ready(function(e){ 
// $(document).on("click", "#zip_search", function() {
//     console.log("Button clicked!");

//     var postal_code = $('#postal_code').val();
//     console.log("Postal Code:", postal_code);

//     $('#input_postcode').val(postal_code);
//     $("#search_postcode").trigger("click");

//     setTimeout(function() {
//         $(".appended-shipping").remove();
//         $("#hidden-shipping-message").remove();
      
//         if ($("#cs_shipping_rate .form .ShippingEstimator__Error ").hasClass("activeMsg")) {
//             var errorMessage = $("#cs_shipping_rate .form").attr('data-ship_err');
//           console.log("errorMessage",errorMessage);
//             if (errorMessage.length > 0) {
//                 $(".input-content-block").after('<div id="hidden-shipping-message" class="shipping-mass" style="display: block;color: red;"></div>');
//                 $("#hidden-shipping-message").append(errorMessage);
//             }
//         } else {
//             // Store success message but don't show it yet
//             var shippingElement = $("#shipping_rates").clone();   
//           console.log("shippingElement",shippingElement);
          
//             if (shippingElement.length > 0) {
//                 shippingElement.css("display", "block").addClass("appended-shipping");
//                 $(".input-content-block").after('<div id="hidden-shipping-message" style="display: none;"></div>');
//                 $("#hidden-shipping-message").append(shippingElement);
//             }
//         }
//     }, 2000);
// });

$('body').on("click", ".cs-tab_last", function(e) {
    e.preventDefault();
    setTimeout(() => {
        let activeTab = $('.cs-crawler-tabs li.active'); 
        if (activeTab.attr("rel") === "cs-tab3") {
            // $('#input_postcode').val('');
            // $("#search_postcode").trigger("click");
           $("#hidden-shipping-message").hide();
           $('#input_postcode').val('').promise().done(() => {
                $("#search_postcode").trigger("click");
            });
        }
        else if (activeTab.attr("rel") === "cs-tab1") {      
          // $('#input_postcode').val('');
          // $("#search_postcode").trigger("click");
          $('#cs-tab1 .tab-inner-content p').text("Please checkout as normal and we will be in contact regarding the overseas shipping charge.");
         $("#hidden-shipping-message").hide();
         $('#input_postcode').val('').promise().done(() => {
              $("#search_postcode").trigger("click");
          });
      }
    }, 100);
});

// $(document).on("input blur", "#csDatepicker", function() {
//     var selectedDate = $(this).val();
//     if (selectedDate.trim() !== "") {
//         $("#hidden-shipping-message").css("display", "block");
//     } 
// });

  // Submit the form with an ajax/jsonp request.
  // Based on http://stackoverflow.com/a/15120409/215821
  function submitSubscribeForm($form, $resultElement) {
    $.ajax({
      type: "GET",
      url: $form.attr("action"),
      data: $form.serialize(),
      cache: false,
      dataType: "jsonp",
      jsonp: "c", // trigger MailChimp to return a JSONP response
      contentType: "application/json; charset=utf-8",
      error: function(error){
        // According to jquery docs, this is never called for cross-domain JSONP requests
      },
      success: function(data){
        if (data.result != "success") {
          var message = data.msg || "Sorry. Unable to subscribe. Please try again later.";
          $resultElement.css("color", "#ff5f6a");
          if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
            message = "You're already subscribed. Thank you.";
            $resultElement.css("color", "#ff5f6a");
          }
          $resultElement.html(message);
        } else {
          $resultElement.css("color", "#ff5f6a");
          $resultElement.html("Thank you!");
        }
      }
    });
  }
  // Turn the given MailChimp form into an ajax version of it.
  // If resultElement is given, the subscribe result is set as html to
  // that element.
  function ajaxMailChimpForm($form, $resultElement){
    // Hijack the submission. We'll submit the form manually.
    $form.submit(function(e) {
      e.preventDefault();
      if (!isValidEmail($form)) {
        var error =  "A valid email address must be provided.";
        $resultElement.html(error);
        $resultElement.css("color", "#ff5f6a");
      } else {
        $resultElement.css("color", "#ff5f6a");
        $resultElement.html("Subscribing...");
        submitSubscribeForm($form, $resultElement);
      }
    });
  }
  ajaxMailChimpForm($("#newsletter-form-mailchimp"), $("#subscribe-result"));
  ajaxMailChimpForm($("#newsletter-form-mailchimp1"), $("#subscribe-result1"));

    // Validate the email address in the form
  function isValidEmail($form) {
    // If email is empty, show error message.
    // contains just one @
    var email = $form.find("input[type='email']").val();
    if (!email || !email.length) {
      return false;
    } else if (email.indexOf("@") == -1) {
      return false;
    }
    return true;
  }
  $('body').on('click','.plus',function(e){
    e.preventDefault();
    $(this).prev().val(+$(this).prev().val() + 1);
  });
  $('body').on('click','.minus',function(e){
    e.preventDefault();
    if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
  });
  
  // main product add to cart
  $('body').on('click','.add-to-cart',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    btn.attr('disabled', 'disabled');
    btn.text('adding...');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        btn.text('ADD TO CART');
        btn.removeAttr('disabled');
      }
    }).done(function( data ) {
      btn.text('ADD TO CART');
      btn.removeAttr('disabled');
      jQuery.getJSON('/cart.js', function (cart) {
          $('.bagamount').html(cart.item_count);
      });
      location.reload();
    });
  });
  // main product add to end
  $('body').on('change', '.measurement-per-unit', function(event) {
    $('.update_btn').prop('disabled', false); // Remove the disabled attribute
  });
  
  // main cart update start
  $('body').on('click', '.update_btn', function(event) {
    event.preventDefault();
    var data = {
      updates: []
    }
    $('.main-cart-form__cart-item').each(function () {
      var get_quantity = $(this).find('input').val();
      data.updates.push(get_quantity);
    });
    $(".all_item").addClass("main_cart_loader");
    $(".cart_totals").addClass("main_cart_loader");
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: data,
      dataType: 'json',
      success: function () {
        $.get("/cart?view=ajax-main-cart", function(data, status){
          var mainItemsBoxHtml = $(data).find('.main-items-box').html();
          setTimeout(function() {
            $(".all_item").removeClass("main_cart_loader");
            $(".cart_totals").removeClass("main_cart_loader");
            $('.main-items-box').html(mainItemsBoxHtml);
          }, 500);
          
          $('.measurement-per-unit').on('change', function() {
            $('.update_btn').prop('disabled', false); // Remove the disabled attribute
          });
         jQuery.getJSON('/cart.js', function (cart) {
              $('.bagamount').html(cart.item_count);
          });
        });
      }
    });
  });
  // main cart update on qty_update start
  $('body').on('click', '.update_btn', function(event) {
    event.preventDefault();
    var data = {
      updates: []
    }
    $('.main-cart-form__cart-item').each(function () {
      var get_quantity = $(this).find('input').val();
      data.updates.push(get_quantity);
    });
    $(".all_item").addClass("main_cart_loader");
    $(".cart_totals").addClass("main_cart_loader");
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: data,
      dataType: 'json',
      success: function () {
        $.get("/cart?view=ajax-main-cart", function(data, status){
          var mainItemsBoxHtml = $(data).find('.main-items-box').html();
          setTimeout(function() {
            $(".all_item").removeClass("main_cart_loader");
            $(".cart_totals").removeClass("main_cart_loader");
            $('.main-items-box').html(mainItemsBoxHtml);
          }, 500);
          
          $('.measurement-per-unit').on('change', function() {
            $('.update_btn').prop('disabled', false); // Remove the disabled attribute
          });
         jQuery.getJSON('/cart.js', function (cart) {
              $('.bagamount').html(cart.item_count);
          });
        });
      }
    });
  });
  // main cart update qty_update end
$(document).on('change', '.measurement-per-unit', function(event) {
  event.preventDefault();

  var data = {
    updates: []
  };

  $('.main-cart-form__cart-item').each(function () {
    var get_quantity = $(this).find('input').val();
    data.updates.push(get_quantity);
  });

  $(".all_item").addClass("main_cart_loader");
  $(".cart_totals").addClass("main_cart_loader");

  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: data,
    dataType: 'json',
    success: function () {
      $.get("/cart?view=ajax-main-cart", function(data, status){
        var mainItemsBoxHtml = $(data).find('.main-items-box').html();

        setTimeout(function() {
          $(".all_item").removeClass("main_cart_loader");
          $(".cart_totals").removeClass("main_cart_loader");
          $('.main-items-box').html(mainItemsBoxHtml);
        }, 500);

        // No need to re-bind the change handler anymore!
        // The delegated handler will continue to work.
        
        jQuery.getJSON('/cart.js', function (cart) {
          $('.bagamount').html(cart.item_count);
        });
      });
    }
  });
});
  // main cart item remove start
   $('body').on('click', '.cart-item-remove', function(event) {
     event.preventDefault();
     var cartItem = $(this).closest('.main-cart-form__cart-item');
     var currentVariant = cartItem.find('input').attr('id');
     $(".all_item").addClass("main_cart_loader");
     $(".cart_totals").addClass("main_cart_loader");
     $.ajax({
       type: "POST",
       url: "/cart/change.js",
       data: {
         quantity: 0,
         id: currentVariant
       },
       dataType: 'json',
       success: function (succ) {         
         $.get("/cart?view=ajax-main-cart", function(data, status){
           var mainItemsBoxHtml = $(data).find('.main-items-box').html();           
           $('.main-items-box').html(mainItemsBoxHtml);
         });
         jQuery.getJSON('/cart.js', function (cart) {
              $('.bagamount').html(cart.item_count);
          });
       }
     });
   });
  // main cart item remove end
  
  $("body").on('click', ".popup-closer,.keep_shop", function(e){
    e.preventDefault();
    var $parents = $('.popup-active').attr('data-popup');
    $(this).closest(".cs-popup").removeClass("popup-active");
    $('.overlay').removeClass("popup-active");
    var video =   document.getElementById($parents);
    if(video){
      video.pause();
    }
  });

  $("body").on('click', ".color input", function(e){
    var radioValue = $(this).val();
    if(radioValue){
     $(this).parent().parent().siblings().children('.color_name').text(radioValue);
    }
  });

  $("body").on('click', "a.top-arrow.w-inline-block", function(e){
    $("html").animate({ scrollTop: 0 }, "slow");
  });
  
  /* homeproduct tab*/ 
  $('a.s8-product-pcs-btn.w-button').click(function(e){
    e.preventDefault();
    $('.s8-filtry-div-desktop .w-col.w-col-4.w-col-stack').removeClass('active');
    var pro=$(this).attr('href');
    $('.s8-filtry-div-desktop '+pro).addClass('active');
    if($('.slider-for').hasClass('slick-initialized')) {
        $('.slider-for').slick('refresh');
      } else {
        $('.slider-for').slick();
      }
    if($('.slider-nav').hasClass('slick-initialized')) {
        $('.slider-nav').slick('refresh');
      } else {
        $('.slider-nav').slick();
      }
  });

  // search js`
  $("body").on("click", ".header_search > a", function (e) {
    e.preventDefault();
    $('.search_bar_main, body').addClass('is-open');
  });
  $("body").on("click", ".search_close", function (e) {
    e.preventDefault();
    $(this).parent().removeClass('is-open');
    $('body').removeClass('is-open');
  });

  // contact modal js`
  $("body").on("click", ".header_icon_wpr .mail_icon a", function (e) {
    e.preventDefault();
    $('.contact_popup_main, body').addClass('is-open');
  });

  // Prevent clicks inside '.contact_popup_inn' from closing the popup
  $('.contact_popup_inn').on('click', function (e) {
    e.stopPropagation();
  });

  $("body").on("click", ".contact_popup_main", function (e) {
    e.preventDefault();
    $(this).removeClass('is-open');
    $('body').removeClass('is-open');
  });

  // mobile menu js
  $("body").on("click", ".toggle_menu", function (e) {
    e.preventDefault();
    if ($(this).hasClass("is-open")) {
      $(this).removeClass('is-open');
      $(".header_menu_wpr, body").removeClass('is-open');
    } else{
      $(this).addClass('is-open');
      $(".header_menu_wpr, body").addClass('is-open');
    }
  });
  
  const swiper = new Swiper('.t_product_slider', {
    slidesPerView: 1,
    spaceBetween: 10,
    slidesPerGroup: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      769: {
        slidesPerView: 3,
       slidesPerGroup: 3,
      },
      526: {
        slidesPerView: 2,
      }
    },
  });
  var P_thumbs1 = new Swiper ('.pdp_gallery_thumbs', {
      slidesPerView: 4,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      spaceBetween: 20,
      breakpoints: {
        526: {
          slidesPerView: 5,
        }
      }
  });
  var P_slider1 = new Swiper ('.pdp_gallery_slider', {
      slidesPerView: 1,
      thumbs: {
        swiper: P_thumbs1,
      },
  });
  Fancybox.bind("[data-fancybox]", {
    Thumbs: false,
    Carousel: {
      transition: 'slide',
      infinite: false,
    },
    Zoom: {
      maxScale: 4, // Adjust this for max zoom scale
    },
  });

 $('.tab_content_center ul.tabs li').click(function (e) {
    e.preventDefault();
    var $parent = $(this).closest('.has_parent');
    var tab_id = $(this).attr('id');
    
    // Check if the clicked tab already has the 'current' class
    if ($(this).hasClass('current')) {
        // If it has the 'current' class, remove it along with the corresponding content
        $(this).removeClass('current');
        $parent.find('.tab_content_inner[data-tab="' + tab_id + '"], .tab_content_img[data-tab="' + tab_id + '"]').removeClass('current');
    } else {
        // If it doesn't have the 'current' class, show the tab content and mark it as 'current'
        $parent.find('ul.tabs li, .tab_content_inner, .tab_content_img').removeClass('current');
        $(this).addClass('current');
        $parent.find('.tab_content_inner[data-tab="' + tab_id + '"], .tab_content_img[data-tab="' + tab_id + '"]').addClass('current');
    }
});

  /* Predictive search : Start */
  $("body").on('input', '.js-search', function() {
    var $this = $(this);
    let searchTerm = $(this).val();    
    if( searchTerm ){
      // $.get(`/search/suggest?q=${searchTerm}&resources[type]=product,article,collection,page&section_id=predictive-search`, function(data) {        
      //   $this.closest("form").find('.prediactive_search').html($(data).html());
      // });
      $.get(`/search/suggest?q=${searchTerm}&section_id=predictive-search`, function(data){
        $this.closest("form").find('.prediactive_search').html($(data).html());
      })
    }
  });
 /* Predictive search : End */

/*  Collection page product filters: start */
  var main_arr = [];  
  var current_url = $('[data-filter-url]').data('col');
  var section_c_id = $('[data-filter-url]').data('id');

  // Function to update the URL for apply and clear buttons
  function get_data(url) {    
    $(".apply-filters").attr("href", url);
    $(".clear-filters").attr("href", current_url);    
  }

  // Function to update the filter array based on selected checkboxes
  function update_filter(arr) {
    $('[data-filter-box]:not([data-filter-price-box])').each(function() {
      $(this).find('.filter_checkbox input:checked').each(function() {
        var filter_name = $(this).data('name');
        var filter_value = $(this).data('value');
        if (filter_name && filter_value) {
          var final = `${filter_name}=${filter_value}`;
          if (!arr.includes(final)) {
            arr.push(final);
          }
        }
      });
    });

    // Handle sorting filter
    if ($('.or-nice-select').length) {
      let filter_value = $('.or-nice-select').val();
      if (filter_value) {
        arr.push(`sort_by=${filter_value}`);
      }
    }

    // Handle price filter
    var price_input = $('input[name="filter.v.price"]:checked');
    if (price_input.length) {
      let name = price_input.data("parameter");
      let value = price_input.val();
      if (name && value) {
        arr.push(`${name}=${value}`);
      }
    }
    main_arr = arr; // Update main array
  }

  // Event handler for checkbox click in filters
  $('body').on('click', '.filter_checkbox input', function(e) {
    //e.preventDefault();
    var search_param = [];
    update_filter(search_param);     
    var get_url = `${current_url}?${main_arr.join('&')}`;
    if (main_arr != '') {
      history.pushState({ search_param }, '', window.location.pathname+'?'+main_arr.join('&'));
    } else {
      history.pushState({ search_param }, '', window.location.pathname);
    }
    get_data(get_url);
    // Update current selected value count
    var $selectedCount = $(this).closest(".product_filter_option").find('.selected-count span');
    var count = parseInt($selectedCount.text());
    count = $(this).is(':checked') ? count + 1 : count - 1;
    $selectedCount.text(count);
  });

  // Event handler for sorting with AJAX
  $('body').on('click', '#sort li a', function(e) {
    e.preventDefault();
    let filter_value = $('.or-nice-select').val();
    if (filter_value) {
      $('.collection_grid').removeClass('flex').html('<div class="loading-spinner" style="text-align: center;">Loading...</div>');
      let newUrl = `${current_url}?sort_by=${filter_value}`;
      var search_param = [];
      update_filter(search_param);     
      var get_url = `${current_url}?${main_arr.join('&')}`;
      if (main_arr != '') {
        history.pushState({ search_param }, '', window.location.pathname+'?'+main_arr.join('&'));
      } else {
        history.pushState({ search_param }, '', window.location.pathname);
      }
      $.ajax({
        url: get_url,
        method: 'GET',
        success: function(data) {
          $('.collection_grid').addClass('flex').html($(data).find('.collection_grid').html());
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error('Error fetching sorted products:', textStatus, errorThrown);
        }
      });
    }
  });

  // Event handler for price filter
  $('body').on('change', 'input[name="filter.v.price"]', function() { 
    var search_param = [];
    update_filter(search_param);
    var get_url = `${current_url}?${main_arr.join('&')}`;  
    if (main_arr != '') {
      history.pushState({ search_param }, '', window.location.pathname+'?'+main_arr.join('&'));
    } else {
      history.pushState({ search_param }, '', window.location.pathname);
    }
    get_data(get_url);
    // Update current selected value count for price filter
    let selectedCount = $(this).closest(".product_filter_option").find('.selected-count span');
    selectedCount.text($(this).is(':checked') ? 1 : 0);
  });

  // Initialize selected filter counts
  if ($('.product_filter_info').length) {
    $(".product_filter_info .filter_option_item__menu").each(function() {
      var countVal = 0;
      $(this).find("li").each(function() {
        if ($(this).find('input:checked').length) {
          countVal++;
        }
      });
      $(this).closest(".product_filter_option").find('.selected-count span').text(countVal);
    });
  }

  // Event handler for clearing filter options
  $('body').on('click', '.option_clear', function(e) {
    e.preventDefault();
    var $filterOption = $(this).closest(".product_filter_option");
    $filterOption.find("input").prop('checked', false);
    $filterOption.find('.selected-count span').text(0);
    var search_param = [];
    update_filter(search_param); 
    if (main_arr != '') {
      history.pushState({ search_param }, '', window.location.pathname+'?'+main_arr.join('&'));
    } else {
      history.pushState({ search_param }, '', window.location.pathname);
    }
    var get_url = `${current_url}?${main_arr.join('&')}`;
    get_data(get_url);
  });

/*  Collection page product filters: End */
  $("body").on("click", ".product_filter_block", function (e) {
    e.preventDefault();
    $(".product_filter_block").removeClass("active");
    $(".product_filter_info").slideUp();
    if (!$(this).next().is(":visible")) {
        $(this).next().slideDown();
        $(this).addClass("active");
    }
 });

  $("body").on("click", ".collection_fill a.filter-drawer", function (e) {
      e.preventDefault();
      $('.collection_overlay, .collection_wrapper, body').addClass('is-open');
  });
  
  $("body").on("click", ".filter_close_btn, .collection_overlay", function (e) {
      e.preventDefault();
      $('.collection_overlay, .collection_wrapper').removeClass('is-open');
      $('body').removeClass('is-open');
  });

  $('.or-nice-select').each(function () {
    var select = $(this),
    name = select.attr('name');
    select.hide();
    select.wrap('<div class="nice-select-wrap"></div>');
    var parent = select.parent('.nice-select-wrap');
    parent.append('<ul id=' + name + ' style="display:none"></ul>');
    var selected = $('.nice-select').find(":selected").val();
    select.find('option').each(function () {
    var option = $(this),
    value = option.attr('value'),
    label = option.text();
    if (option.is(":first-child")) {
        $('<a href="javascript:void(0)" class="drop">' + label + '</a>').insertBefore(parent.find('ul'));
    } else if(selected == value){
        var shortBy = $('.nice-select').find('[value="sort-by"]').text();
        var niceOption = $(this),
        text = niceOption.text();        
        parent.find('.drop').text( shortBy + text).addClass('filter-active');
        parent.find('ul').append('<li><a class="active sort_active" href="javascript:void(0)" id="' + value + '" value="' + value + '"><span></span>' + label + '</a></li>');
    } else {
        parent.find('ul').append('<li><a href="javascript:void(0)" id="' + value + '" value="' + value + '"><span></span>' + label + '</a></li>');
    }
  });
  parent.find('a').on('click', function (e) {
  parent.toggleClass('down').find('ul').slideToggle(300);
  e.preventDefault();
  });
  parent.find('ul a').on('click', function (e) {
      var shortBy = $('.nice-select').find('[value="sort-by"]').text();
      var niceOption = $(this),
      value = niceOption.attr('id'),
      text = niceOption.text();
      select.val(value);
      parent.find('.drop').text( shortBy + text).addClass('filter-active');
      e.preventDefault();
      $(this).closest('#sort').find('li a').removeClass('active sort_active');
      $(this).addClass('active sort_active');
    });
  });

  if($(".drop").length > 0){
    $(".drop").text( $('.or-nice-select option:selected').text());
  }
});